import { HTMLChakraProps } from '@chakra-ui/react';
import { useResourceRelationship, useResources } from 'datx-jsonapi-react';
import { useRouter } from 'next/router';
import { FC, useMemo } from 'react';

import { EventTicketPrompt } from '@/components/ui/shared/event-ticket/EventTicketPrompt/EventTicketPrompt';
import { checkIsEventPagePublic } from '@/components/ui/shared/overlays/NoTicketCheck/NoTicketCheck.utils';
import { NAVIGATION_ITEMS } from '@/constants/event-app-navigation-items';
import useSession from '@/hooks/useSession';
import { queryThinEventConfigurationRelationship } from '@/queries/thin-events';
import { EventConfiguration } from '@/resources/EventConfiguration';
import { EventTicket } from '@/resources/EventTicket';

export interface IEventTicketRegisterProps extends HTMLChakraProps<'div'> {
  eventId: string;
}

export const EventTicketRegister: FC<IEventTicketRegisterProps> = ({ eventId }) => {
  const { user } = useSession();
  const router = useRouter();

  const { data: eventConfiguration, error: eventConfigurationError } = useResourceRelationship<EventConfiguration>(
    queryThinEventConfigurationRelationship(eventId)
  );

  const isPublic = useMemo(
    () => eventConfiguration && checkIsEventPagePublic(NAVIGATION_ITEMS, router.asPath, eventConfiguration),
    [router, eventConfiguration]
  );

  const { data: tickets, error: ticketsError } = useResources(() => [
    EventTicket,
    {
      filter: {
        event_id: eventId,
        user_id: user.id,
      },
    },
  ]);

  const isLoading = (!eventConfiguration && !eventConfigurationError) || (!tickets && !ticketsError);

  // show while loading or when it's enabled and user doesn't have a ticket
  const shouldShow = isLoading || tickets?.length === 0;

  if (isPublic) return null;
  return shouldShow ? <EventTicketPrompt eventId={eventId} maxW="xl" mt={[6, null, 8]} /> : null;
};
